import React from "react";

import {
    BrowserRouter,
    Switch,
    Route,
    Link,
    NavLink
} from "react-router-dom";
import { Redirect } from 'react-router'

import { CasinoLink } from './CasinoLink.jsx'
import { Raspolozivo } from '../Account/Raspolozivo.jsx'
import './HeaderTablet.less';

export class HeaderTablet extends React.Component {

    constructor(props) {
        super(props);
        this.state = { hiddenNavigationShown: false, miniLoginShown: false, quickUserShown: false, loginInProgress: false, redirect: false };

        this.toggleMenu = this.toggleMenu.bind(this);
        this.showMiniLogin = this.showMiniLogin.bind(this);
        this.hideMiniLogin = this.hideMiniLogin.bind(this);
        this.setLoginInProgress = this.setLoginInProgress.bind(this);
        this.miniLoginBlur = this.miniLoginBlur.bind(this);
        this.miniLoginFocus = this.miniLoginFocus.bind(this);
        this.login = this.login.bind(this);
        this.refreshRaspolozivo = this.refreshRaspolozivo.bind(this);
        this.toggleQuickUser = this.toggleQuickUser.bind(this);
        this.checkLogin = this.checkLogin.bind(this);
        this.renderMenu = this.renderMenu.bind(this);
        this.registracijaClick = this.registracijaClick.bind(this);

        this.form = React.createRef();
        this.username = React.createRef();
        this.password = React.createRef();
        this.prijava = React.createRef();
        this.onThemeChange = this.onThemeChange.bind(this);
    }

    onThemeChange() {
        this.forceUpdate();
    }


    toggleMenu() {

        this.setState({
            hiddenNavigationShown: !this.state.hiddenNavigationShown,
            miniLoginShown: false,
            quickUserShown: false
        })
    }
    showMiniLogin() {
        this.checkLogin();
        this.setState({
            miniLoginShown: true,
            quickUserShown: false,
            hiddenNavigationShown: false
        });
    }

    componentDidUpdate() {
        if (this.state.miniLoginShown) {
            this.username.current.value = "";
            this.password.current.value = "";
            this.username.current.focus();
        }
    }
    componentDidMount() {
        window.addEventListener("casinoThemeChange", this.onThemeChange);
    }
    hideMiniLogin() {
        if (!this.state.loginInProgress) {
            this.setState({
                miniLoginShown: false
            })
        }
    }
    setLoginInProgress(value) {
        this.setState({
            loginInProgress: value
        })
    }
    miniLoginBlur() {
        clearTimeout(this.miniBlagajnaTimer);
        this.miniBlagajnaTimer = setTimeout(() => this.hideMiniLogin(), 300);
    }
    componentWillUnmount() {
        clearTimeout(this.miniBlagajnaTimer);
        window.removeEventListener("casinoThemeChange", this.onThemeChange);
    }
    miniLoginFocus() {
        this.checkLogin();
        clearTimeout(this.miniBlagajnaTimer);
    }
    login(e) {
        e.preventDefault();
        var username = this.username.current.value;
        var password = this.password.current.value;
        this.prijava.current.disabled = true;

        this.setLoginInProgress(true);
        this.props.showLoadingFn(true);
        var that = this;

        let ttId = casino.utils.getCookie("_tdid");
        if (ttId == null) {
            ttId = casino.utils.uuidv4();
            casino.utils.setCookie("_tdid", ttId, 180);
        }

        casino.repos.sessionRepo.create(username, password, ttId).then(function (login) {
            that.setLoginInProgress(false);
            that.props.showLoadingFn(false);
            that.hideMiniLogin();

            if (!login.ok) {
                that.props.doRedirectFn(that.props.getHomePathFn(that.props.route.location, '/login'), { failedLogin: true, from: that.props.route.location, username: username, loginError: login.loginError });
            }
            else {
                that.props.showUserFn(login.sesija.igrac, login.sesija.sesijaId);
                if (typeof ga !== 'undefined')  // google analytics
                    ga('send', { hitType: 'event', eventCategory: 'Actions', eventAction: 'UspjesnaPrijava' });

                //Google tag manager
                casino.utils.createGoogleTagManagerEvent({
                    'event': 'userID',
                    'user_id': login.sesija.igrac.token,
                    'accountID': login.sesija.igrac && login.sesija.igrac.publicID || ""
                });


                //GA360
                casino.utils.createGoogleTagManagerEvent({
                    'userInformation': {
                        'user.profile.accountID': login.sesija.igrac && login.sesija.igrac.publicID || "",
                        'user.profile.bal': login.sesija.igrac != null && login.sesija.igrac.casinoRaspolozivoZaIsplatu != null ? login.sesija.igrac.casinoRaspolozivoZaIsplatu : 0,
                        'user.profile.currency': "EUR",
                        'user.profile.country': "HR",
                        'user.session.geoIPCountry': casino.config.iPAddress,
                        'user.hasPositiveBalance': login.sesija.igrac && login.sesija.igrac.casinoRaspolozivoZaIsplatu > 0 ? true : false,
                        'user.isAuthenticated': true,
                        'user.isExisting': login.sesija.igrac ? true : false
                    }
                });

                //GA360
                var browserScreenResolution = window.screen.width + 'x' + window.screen.height;
                var browserOrientation = window.matchMedia("(orientation: portrait)").matches ? 'PORTRAIT' : 'LANDSCAPE';

                casino.utils.createGoogleTagManagerEvent({
                    'browserInformation': {
                        'browser.userAgent': casino.config.userAgent,
                        'page.culture': casino.config.cultureInfo,
                        'page.frontend': "mobile",
                        'page.domain': "https://mcasino.supersport.hr/",
                        'page.medium': "mobile web",
                        'browser.orientation': browserOrientation,
                        'browser.screenResolution': browserScreenResolution
                    }
                });


                let raceId = sessionStorage.getItem('casino-utrka');
                if (raceId) {
                    that.setState({ redirect: true });
                }
            }
        });
    }
    refreshRaspolozivo() {
        this.props.fetchUserFn();
    }
    toggleQuickUser() {
        this.setState({
            quickUserShown: !this.state.quickUserShown,
            miniLoginShown: false,
            hiddenNavigationShown: false
        });
    }
    checkLogin() {
        var username = this.username.current.value;
        var password = this.password.current.value;

        this.prijava.current.disabled = !(username.length > 3 && password.length > 3);
    }
    renderMenu() {
        return this.props.renderMenuFn(null, null, true).map((x, index) => React.cloneElement(x, {
            onClick: function () {
                this.props.showSearchFn(false)
            }.bind(this),
            key: index
        }));
    }
    registracijaClick() {
        if (typeof ga !== 'undefined')  // google anayltics
            ga('send', { hitType: 'event', eventCategory: 'Clicks', eventAction: 'Registracija Click' });

        //Facebook pixel
        //fbq('track', 'CompleteRegistration');
    }

    //switchCurrency(e) {
    //    let currency = e.target.checked ? 'eur' : 'kn';
    //    let currencyisEuro = currency == 'eur' ? true : false;
    //    localStorage.setItem('activeCurrency', currency);
    //    this.props.changeCurrency(currencyisEuro);
    //    location.reload();
    //}

    render() {
        if (this.state.redirect) {
            let redirectRoute = "/casino-utrke/" + sessionStorage.getItem('casino-utrka');
            sessionStorage.removeItem('casino-utrka');
            return <Redirect to={redirectRoute} push={true} />
        }

        var isLightTheme = casino.utils.getCasinoTheme() !== "dark";

        return (
            <div className="header-tablet" onClick={() => this.props.showSearchFn && this.props.showSearchFn(false)}>
                <NavLink to={this.props.getHomePathFn(this.props.route.location)} className="pull-left">
                    <Switch>
                        <Route path='/poker' render={(route) =>
                        (
                            <img src="content/images/assets/SuperPoker_red.png" className="logo-png" alt="SuperPoker"></img>
                            //<span className="icon ico-supersport-logo logo" />
                        )} />
                        <Route path='/info/poker' render={(route) =>
                        (
                            <span className="icon ico-supersport-logo logo" />
                        )} />
                        <Route render={(route) =>
                        (
                            <picture>
                                <source srcSet={casino.utils.getCasinoTheme() === "dark" ? "Content/Images/Assets/SuperCasinoLogoWhite.avif" : "Content/Images/Assets/SuperCasinoLogoRed.avif"} type="image/avif" />
                                <source srcSet={casino.utils.getCasinoTheme() === "dark" ? "Content/Images/Assets/SuperCasinoLogoWhite.webp" : "Content/Images/Assets/SuperCasinoLogoRed.webp"} type="image/webp" />                                    
                                <img src={casino.utils.getCasinoTheme() === "dark" ? "content/images/assets/SuperCasinoLogoWhite.png" : "content/images/assets/SuperCasinoLogoRed.png"} className="logo-png" alt="SuperCasino"></img>
                            </picture>
                            //<span className="icon ico-supersport-logo logo" />
                        )} />
                    </Switch>
                </NavLink>

                <ul className="horizontal-menu pull-left" >
                    {this.renderMenu()}
                    <li className={this.state.hiddenNavigationShown ? 'tockice selected' : 'tockice'}>
                        <a onClick={(e) => { e.preventDefault(); this.toggleMenu }}>
                            <span className="icon ico-menu-circles-hor"></span>
                        </a>
                        <ul className="hidden-horizontal-menu arrow_top shadow" >
                            {this.renderMenu()}
                        </ul>
                    </li>
                </ul>

                <div className="user-part">
                    <div className={this.props.userChecked ? '' : 'hidden'}>
                        <div className={this.props.user ? 'hidden' : ''}>
                            {/*<input type="text" className="center-verticaly login-link input" placeholder="nadimak ili email" onClick={this.showMiniLogin} />*/}
                            <NavLink className={"btn small prijava pull-right center-verticaly " + (isLightTheme ? "fill red" : "outline white")}
                                to={{ pathname: this.props.getHomePathFn(this.props.route.location, '/login'), state: { from: this.props.route.location.pathname } }}
                                onClick={() => this.props.showSearchFn && this.props.showSearchFn(false)}>
                                Prijava</NavLink>
                        </div>

                        <form ref={this.form} className={this.state.miniLoginShown || this.state.loginInProgress ? 'shown shadow' : ''} onBlur={this.miniLoginBlur} onFocus={this.miniLoginFocus}>
                            <input className="input" type="text" ref={this.username} placeholder="nadimak ili email" onChange={this.checkLogin} onKeyPress={this.checkLogin} />
                            <input className="input" type="password" ref={this.password} placeholder="lozinka" onChange={this.checkLogin} onKeyPress={this.checkLogin} />
                            <button className="btn medium fill blue" onClick={this.login} ref={this.prijava}>Prijavi me</button>
                            <CasinoLink href={casino.config.urls.zaboravljenaLozinka}>
                                <span className="icon ico-expand-fill"></span><span>Zaboravio sam lozinku</span>
                            </CasinoLink>
                            <a href={casino.config.urls.registracija} onClick={this.registracijaClick}>
                                <span className="icon ico-edit-fill-off"></span><span>Želim se registrirati</span>
                            </a>
                        </form>

                        <div className={this.props.user ? 'user-info' : 'hidden'}>
                            <div className="pull-right" onClick={this.refreshRaspolozivo}>
                                <span className="icon ico-sync"></span>
                            </div>
                            <div className={this.state.quickUserShown ? 'nadimak selected' : 'nadimak'}>
                                <div className="height-auto" onClick={this.toggleQuickUser}>
                                    <span className="icon ico-triangle-down"></span>
                                    <span className="text-ellipsis">{this.props.user && this.props.user.nadimak}</span>
                                    {casino.config.guiValuta == "EUR" &&
                                        <span>
                                            {this.props.user && !this.props.iznosSkriven && casino.utils.numberWithCurrencyFromated(this.props.user.casinoRaspolozivo, this.props.user.valuta)}
                                            {this.props.user && this.props.iznosSkriven && "XXXXX €"}
                                        </span>
                                    }
                                </div>
                                <div className="quick-user arrow_top arrow_top_right shadow">
                                    <button className="link odjava" onClick={() => this.props.logoutFn(true)}>
                                        <span className="icon ico-logout"></span><span>Odjavi me</span>
                                    </button>
                                    <button className="link sakrij-iznos pull-right" onClick={this.props.toggleSakrijIznosFn}>
                                        <span>{!this.props.iznosSkriven ? 'Sakrij iznos' : 'Prikaži iznos'}</span>
                                    </button>
                                    <div className="padding-sides-medium" style={{ height: 'auto' }}>
                                        <Raspolozivo user={this.props.user}></Raspolozivo>
                                    </div>

                                    <div className="links clearfix">
                                        <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account')} onClick={this.toggleQuickUser}><span>Račun</span><span className="icon ico-chevron-right"></span></NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};
